/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_Source_LanguageInputs */

const en_select_source_language = /** @type {(inputs: Select_Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the source language for transcription`)
};

const fr_select_source_language = /** @type {(inputs: Select_Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez la langue source pour la transcription`)
};

const de_select_source_language = /** @type {(inputs: Select_Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie die Ausgangssprache für die Transkription aus.`)
};

const it_select_source_language = /** @type {(inputs: Select_Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona la lingua di origine per la trascrizione`)
};

const ru_select_source_language = /** @type {(inputs: Select_Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите исходный язык для транскрипции.`)
};

const es_select_source_language = /** @type {(inputs: Select_Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione el idioma de origen para la transcripción`)
};

const zh_cn2_select_source_language = /** @type {(inputs: Select_Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择要转录的源语言`)
};

const ja_select_source_language = /** @type {(inputs: Select_Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`転写のソース言語を選択してください`)
};

const hi_select_source_language = /** @type {(inputs: Select_Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलेखन के लिए स्रोत भाषा का चयन करें`)
};

const pt_pt2_select_source_language = /** @type {(inputs: Select_Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o idioma de origem para transcrição.`)
};

/**
* | output |
* | --- |
* | "Select the source language for transcription" |
*
* @param {Select_Source_LanguageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const select_source_language = /** @type {((inputs?: Select_Source_LanguageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_Source_LanguageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_select_source_language(inputs)
	if (locale === "de") return de_select_source_language(inputs)
	if (locale === "it") return it_select_source_language(inputs)
	if (locale === "ru") return ru_select_source_language(inputs)
	if (locale === "es") return es_select_source_language(inputs)
	if (locale === "zh-CN") return zh_cn2_select_source_language(inputs)
	if (locale === "ja") return ja_select_source_language(inputs)
	if (locale === "hi") return hi_select_source_language(inputs)
	if (locale === "pt-PT") return pt_pt2_select_source_language(inputs)
	return en_select_source_language(inputs)
});